<dashboardnav>
  
  <cradua-facilityasset
  [facilityassets]="facilityassets$ | async"
  (facilityasset)="onSubmitFacilityAsset($event)"
  (deleteFacilityAssetEvent)="onDeleteFacilityAsset($event)"
  *ngIf="(isLoading$ | async ) === false"
  >
</cradua-facilityasset>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoading$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>

